
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import { useState } from 'react';
import dynamic from 'next/dynamic';

import MainLayout from 'global/MainLayout';
import PageLoader from 'global/Loading/PageLoader';
import useProtectedRoute from 'hooks/useProtectedRoute';
import SuccessSubscribeModal from 'features/shop-revamp/components/SuccessSubscribeModal';
import { selectors } from 'global/MainLayout/slice';
import { useSelector } from 'react-redux';

const Stream = dynamic(() => import('features/stream'), { ssr: false });

export const getServerSideProps = ({ query }) => {
  const showSuccessSubscribe =
    query.status_code === '200' && query.transaction_status;

  return {
    props: {
      showSuccessSubscribe,
    },
  };
};

function StreamPage(props) {
  const { showSuccessSubscribe } = props;
  const [showModal, setShowModal] = useState(showSuccessSubscribe);
  const { isLoaded } = useProtectedRoute();
  const { isSideWidgetOpen } = useSelector(selectors);

  const handleSubSuccessModalOK = () => {
    setShowModal(false);
  };

  return (
    <MainLayout maxWidth={isSideWidgetOpen ? 970 : 1037} isFlexibleWidth>
      <PageLoader loaded={isLoaded} />
      <Stream />

      <SuccessSubscribeModal
        visible={showModal}
        onOk={handleSubSuccessModalOK}
      />
    </MainLayout>
  );
}

export default StreamPage;
